import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {isIE11} from '../../helpers/ie.helper';

export const PromotionContent = styled.div`
  display: ${props => props.showPromotionContent ? 'block' : 'none'};
  background-color: ${p => p.textOnly ? 'transparent' : (p.page === 'confirmation' ? p.theme.tertiaryBackground : p.theme.quinaryBackground)};
  padding: ${props => props.theme.padding};
  width: auto;
  margin: ${props => {
    if (props.page === 'menu') {
      return `${props.theme.promotion.margin.desktop}`;
    } else if (props.page === 'gallery' || props.page === 'preview') {
      return `${props.theme.margin} 0`;
    } else if (props.page === 'confirmation') {
      return '0';
    }
  }};
  ${media.medium`
    margin: ${props => {
      if (props.page === 'menu') {
        return `0 ${props.theme.margin} ${props.theme.margin} 0`;
      } else if (props.page === 'gallery' || props.page === 'preview') {
        return `${props.theme.margin} 0`;
      }
    }};
  `}
  ${media.small`
    margin: ${props => {
      if (props.page === 'menu') {
        return `0 0 ${props.theme.margin} 0`;
      } else if (props.page === 'gallery' || props.page === 'preview') {
        return `${props.theme.margin} 0`;
      } else if (props.page === 'confirmation') {
        return '0';
      }
    }};
    width: ${props => props.page === 'confirmation' ? '100%' : 'auto'};
  `}
`;

export const Promotion = styled.p`
  color: ${p => p.theme.secondaryColor};
  font-size: ${p => p.theme.promotion.fontSize};
  font-weight: ${p => p.theme.promotion.fontWeight};
  margin-top: 1rem;
  text-align: center;
  ${isIE11() && `
    width: 100%;
  `}
`;



// WEBPACK FOOTER //
// ./components/Promotions/Promotions.style.js